<template>
    <div
        class="modal-wrapper"
        :class="{ 'modal-wrapper_padding': padding }"
    >
        <span
            class="modal-wrapper__close"
            @click="$parent.$emit('close')"
        >
            <svg class="modal-wrapper__icon"><use xlink:href="#svg-close"></use></svg>
        </span>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'modal-wrapper',
    selector: '.modal-wrapper',
    props: {
        padding: {
            type: Boolean,
            default: true,
        }
    },
}
</script>

<style lang="scss" scoped>
.modal-wrapper{
    &_padding{
        padding: 48px 24px;
        @include point-md{
            padding: 48px;
        }
    }
    &__close{
        display: block;
        position: absolute;
        top: 16px;
        right: 16px;
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
    &__icon{
        display: block;
        width: 16px;
        height: 16px;
        fill: #757575;
    }
}
</style>